import React from 'react';
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles';
import { createTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import WorkContent from './WorkContent';
import Typography from '@material-ui/core/Typography';
import Hidden from '@material-ui/core/Hidden';
import { Button } from '@material-ui/core';

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
})

const useStyles = makeStyles(() => ({
  root: {
    // margin: 20,
    marginTop: 50,
    marginBottom: 50,
    color: '#314e52',
  },
  title: {
    textAlign: "right",
    color: '#314e52',
  },
  button: {
    color: '#314e52',
    textTransform: 'none',
    "&:hover": {
      background: 'none',
    },
  },
  contentbox: {
    [theme.breakpoints.down('md')]: {
      border: 0
    },
  },
}));

const works = ["Claw Sim", "Small Shop"]
const descriptions = {
  "Claw Sim" : "Realistic Claw Simulator Game",
  "Small Shop" : "VR Shop Simulation Game",
}
const links = {
  "Claw Sim" : "https://apps.apple.com/us/app/claw-sim/id6572237567",
  "Small Shop" : "https://store.steampowered.com/app/2070210/Small_Shop/",
}

export default function Works() {
  const classes = useStyles();

  return(
    <div className={classes.root}>
      {works.map((work, index) => ( 
      <div key={index}>
          <Grid container>
           <Hidden mdDown>
            <Grid item lg={5} className={classes.title}> 
              <Box style={{paddingRight:50}}>
                <Button href={links[work]} className={classes.button}>
                  <Typography gutterBottom variant="h6">
                    {work}
                  </Typography>
                </Button>
              </Box>
            </Grid>
            </Hidden>
            <Grid item xs={12} lg={7} className={classes.content}>
              <Box borderLeft={1} style={{paddingLeft:20, paddingRight:20}} className={classes.contentbox}>
                <WorkContent title={work} description={descriptions[work]} link={links[work]}/>
              </Box>
            </Grid>
          </Grid>
      </div>
      ))}
    </div>
  );
}